import { render, staticRenderFns } from "./ConnectedBanksOverview.vue?vue&type=template&id=5b1b89e2&scoped=true&"
import script from "./ConnectedBanksOverview.vue?vue&type=script&lang=js&"
export * from "./ConnectedBanksOverview.vue?vue&type=script&lang=js&"
import style0 from "./ConnectedBanksOverview.vue?vue&type=style&index=0&id=5b1b89e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1b89e2",
  null
  
)

export default component.exports